
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock } from "lucide-react";
import { Link } from "react-router-dom";

interface PasswordInputProps {
  id: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  showForgotPassword?: boolean;
}

export function PasswordInput({
  id,
  value,
  onChange,
  disabled = false,
  showForgotPassword = false,
}: PasswordInputProps) {
  return (
    <div className="space-y-1">
      <div className="flex items-center justify-between">
        <Label htmlFor={id} className="text-left block">Senha</Label>
        {showForgotPassword && (
          <Link to="/reset-password" className="text-xs text-brand-teal hover:underline transition">
            Esqueceu a senha?
          </Link>
        )}
      </div>
      <div className="relative">
        <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 h-4 w-4" />
        <Input
          id={id}
          type="password"
          value={value}
          onChange={onChange}
          className="pl-10 rounded-lg"
          required
          disabled={disabled}
          placeholder="sua senha"
        />
      </div>
    </div>
  );
}
